import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Tabs = ({ tabs, activeTab }) => {
  const tabsRef = useRef(null);
  const lineRef = useRef(null);

  const moveLine = (targetTab, tabsRect) => {
    const padding = 15;
    const targetTabRect = targetTab.getBoundingClientRect();
    const line = lineRef.current;

    const newLeft = targetTabRect.left - tabsRect.left + padding;
    const newWidth = targetTabRect.width - 2 * padding;

    // Extend the line to cover both tabs
    const isMovingRight = newLeft > parseInt(line.style.left || 0);
    const extendedWidth = isMovingRight
      ? newLeft - parseInt(line.style.left || 0) + newWidth
      : parseInt(line.style.width || 0) +
        parseInt(line.style.left || 0) -
        newLeft;

    line.style.transition = "left 0.35s ease, width 0.35s ease";
    if (!isMovingRight) {
      line.style.left = `${newLeft}px`;
    }
    line.style.width = `${extendedWidth}px`;

    // After a delay, shrink the line to fit just the destination tab
    setTimeout(() => {
      line.style.left = `${newLeft}px`;
      line.style.width = `${newWidth}px`;
    }, 350); // Delay should match the transition duration
  };

  useEffect(() => {
    const moveLineOnLoad = () => {
      if (tabsRef.current) {
        const targetTab = tabsRef.current.children[activeTab];
        if (targetTab) {
          const tabsRect = tabsRef.current.getBoundingClientRect();
          moveLine(targetTab, tabsRect);
        }
      }
    };

    // Wait for fonts and window load before moving the line
    document.fonts.ready.then(() => {
      if (document.readyState === "complete") {
        moveLineOnLoad();
      } else {
        window.addEventListener("load", moveLineOnLoad);
      }
    });

    return () => window.removeEventListener("load", moveLineOnLoad);
  }, [activeTab]);

  const renderTabs = () => {
    return tabs.map((t, i) => {
      let className = "tab";
      if (i === activeTab) {
        className += " tab--active";
      }

      return (
        <Link
          to={t.linkTo}
          className={className}
          key={i}
          onClick={() => {
            if (t.onClick) {
              t.onClick();
            }
          }}
        >
          {t.label}
        </Link>
      );
    });
  };

  return (
    <div className="tabs navbar-link" ref={tabsRef}>
      {renderTabs()}
      <div
        className="line"
        ref={lineRef}
        style={{
          left: 0,
          width: 0,
          background: "linear-gradient(to right, #b721ff, #21d4fd)",
          backgroundSize: "200% 100%",
          backgroundPosition: "0% center",
        }}
      ></div>
    </div>
  );
};

export default Tabs;
